module.exports = __webpack_public_path__ + "img/success.6647cc56.svg";